import { FormValues } from './formValues.model';

const initialValue: FormValues = {
  token: '',
  password: '',
  passwordConfirmation: '',
};

export default initialValue;
